import { FunctionComponent, useState } from 'react';
import FursysInquiryButtonWrapper from './fursysInquiryButton.style';
import InquiryActionPopup from '../InquiryActionPopup';
import { sendAmplitudeEvent } from '../../utils/amplitude';

const FursysInquiryButton: FunctionComponent = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const clickQuestion = () => {
    const isOpen = !openPopup;
    setOpenPopup(isOpen);
    sendAmplitudeEvent('sqr_click_fursys', { label: 'request' });
  };

  return (
    <FursysInquiryButtonWrapper>
      <button className="openPopup" onClick={clickQuestion}>
        문의
        <br />
        하기
      </button>
      {openPopup && (
        <div className="fursysQuestionaction--popup-wrap">
          <InquiryActionPopup clickCancel={clickQuestion} />
        </div>
      )}
    </FursysInquiryButtonWrapper>
  );
};

export default FursysInquiryButton;
